// extracted by mini-css-extract-plugin
export default {"bodyWrapper":"PrivacyModal_bodyWrapper__TyM8D","headerWrapper":"PrivacyModal_headerWrapper__vKzkA"};